<template>
  <div class="card card-custom" v-if="user">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de modification d'un utilisateur</h2>
          <FormUser 
          v-model="user" 
          @submit="submit"
          mode="edit"
          ></FormUser>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormUser from "@/components/admin/user/forms/formUser.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "editUser",
  components: {
    FormUser,
  },
  data: () => ({
    user: null,
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes utilisateurs", route: "gestionClients" },
      { title: "Modifier un utilisateur" },
    ]);

    var userId = this.$route.params.id;
    var userData = this.$route.params.user;

    if (userData) {
      this.populateUserForm(userData);

    } else {
      Api.get(`/users/${userId}`).then((user) => {
        this.populateUserForm(user.data);
      });
    }
  },
  methods: {
    submit: async function() {
      
      try {
        await Api.patch("users", this.user.id, {
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          email: this.user.email,
          //password: this.user.password,
          comment: this.user.comment,
          roles: this.user.roles,
          client: this.user.client ? this.user.client['@id'] : null,
          userRight: this.user.userRight ? this.user.userRight['@id'] : null,
          ssoUpdate : this.user.ssoUpdate,
        });
        Swal.fire({
          title: "",
          text: "Les données de l'utilisateur ont été modifiées.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: "gestionClients", query: {
                  selected: "tab-users",
                }, });
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la modification de l'utilisateur",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }
    },

    populateUserForm(user) {
      this.user = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines
        ...user,
      };
    },
  },
};
</script>
